import React from "react";
import { Link, useLocation } from "react-router-dom";

const PortTobBar = ({ list, templateId = "glass" }) => {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [resumeOpen, setResumeOpen] = React.useState(false);
  const location = useLocation();

  const linkBase =
    "inline-flex w-full items-center justify-center rounded-full px-5 py-3 text-sm font-medium backdrop-blur-xl transition xl:w-auto";

  const renderItem = (item) => {
    if (item.key === "download") {
      return (
        <div className="relative">
          <button
            type="button"
            className={`${linkBase} border border-white/15 bg-white/10 text-skin-text hover:bg-white/15`}
            onClick={() => setResumeOpen((current) => !current)}
          >
            {item.title}
          </button>
          {resumeOpen ? (
            <div className="absolute left-0 top-full z-20 mt-3 min-w-56 rounded-3xl border border-white/15 bg-[var(--surface-strong)] p-2 shadow-glass backdrop-blur-xl max-xl:static max-xl:mt-2">
              {item.category.map((entry) => (
                <a
                  key={entry.title}
                  className="block rounded-2xl px-4 py-3 text-sm text-skin-text transition hover:bg-white/10"
                  href={entry.url}
                  rel="noreferrer"
                  target="_blank"
                >
                  {entry.title}
                </a>
              ))}
            </div>
          ) : null}
        </div>
      );
    }

    if (item.key === "url") {
      const isActive = location.pathname === item.url;

      return (
        <Link
          to={item.url ?? "/"}
          className={`${linkBase} ${
            isActive
              ? "bg-[var(--accent)] text-white shadow-lg shadow-[var(--accent-glow)]"
              : "border border-white/15 bg-white/10 text-skin-text hover:bg-white/15"
          }`}
          onClick={() => setMobileOpen(false)}
        >
          {item.title}
        </Link>
      );
    }

    return null;
  };

  return (
    <header className={`portfolio-topbar portfolio-topbar--${templateId} sticky top-4 z-20 mb-10`}>
      <div className="portfolio-topbar__inner mx-auto flex max-w-7xl items-center justify-between gap-3 rounded-[2rem] border border-white/15 bg-white/10 px-4 py-3 shadow-glass backdrop-blur-xl">
        <Link
          to="/"
          className="flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-full border border-white/15 bg-white/90 p-2 shadow-glass transition hover:scale-105"
          onClick={() => setMobileOpen(false)}
          aria-label="Go to home"
        >
          <img src="/images/fav.png" alt="Abdul Rahman" className="h-full w-full object-contain" />
        </Link>

        <nav className="portfolio-topbar__nav hidden min-w-0 flex-1 flex-wrap items-center justify-end gap-2 xl:flex">
          {list.map((item) => (
            <div key={item.title}>{renderItem(item)}</div>
          ))}
        </nav>

        <button
          type="button"
          className="inline-flex h-11 min-w-16 items-center justify-center rounded-full border border-white/15 bg-white/10 px-4 text-sm font-medium text-skin-text xl:hidden"
          onClick={() => setMobileOpen((current) => !current)}
          aria-label="Toggle navigation"
        >
          {mobileOpen ? "Close" : "Menu"}
        </button>
      </div>

      {mobileOpen ? (
        <div className="mx-auto mt-3 grid max-w-7xl gap-3 rounded-[2rem] border border-white/15 bg-[var(--surface-strong)] p-4 shadow-glass backdrop-blur-xl sm:grid-cols-2 xl:hidden">
          {list.map((item) => (
            <div key={item.title}>{renderItem(item)}</div>
          ))}
        </div>
      ) : null}
    </header>
  );
};

export default PortTobBar;
